/**
 * Store en memoria para gestionar day_unique_id de formularios
 *
 * Propósito: Mantener consistencia entre la creación y actualización de formularios
 * para evitar el error "day_unique_id no coincide"
 */

import { generateDayUniqueId } from './basicUtils' // ✅ Importar desde basicUtils

// Map: form_id + schedule_id + store_id => day_unique_id
const formDayUniqueIdMap = new Map<string, string>()

/**
 * Genera una key única para identificar un formulario
 */
function getFormKey(form_id: string, schedule_id: string, store_id: string | null): string {
    return `${schedule_id}:${form_id}:${store_id || 'null'}`
}

/**
 * Obtiene o crea un day_unique_id para un formulario
 * Si ya existe uno en el store, lo retorna. Si no, genera uno nuevo y lo guarda.
 */
export function getOrCreateFormDayUniqueId(form_id: string, schedule_id: string, store_id: string | null): string {
    const key = getFormKey(form_id, schedule_id, store_id)

    let dayUniqueId = formDayUniqueIdMap.get(key)

    if (!dayUniqueId) {
        // Generar nuevo day_unique_id
        dayUniqueId = generateDayUniqueId()
        formDayUniqueIdMap.set(key, dayUniqueId)

        console.log(`✅ Creado day_unique_id para formulario: ${key} => ${dayUniqueId}`)
    }

    return dayUniqueId
}

/**
 * Limpia el day_unique_id de un formulario específico
 * Útil cuando se completa o se resetea un formulario
 */
export function clearFormDayUniqueId(form_id: string, schedule_id: string, store_id: string | null): void {
    const key = getFormKey(form_id, schedule_id, store_id)
    formDayUniqueIdMap.delete(key)
    console.log(`🗑️ Eliminado day_unique_id para formulario: ${key}`)
}

/**
 * Limpia todos los day_unique_id almacenados
 * Útil al cerrar sesión o cambiar de día
 */
export function clearAllFormDayUniqueIds(): void {
    formDayUniqueIdMap.clear()
    console.log('🗑️ Limpiados todos los day_unique_id de formularios')
}

/**
 * Debug: Obtiene el estado actual del store
 */
export function getFormDayUniqueIdStoreState(): Record<string, string> {
    const state: Record<string, string> = {}
    formDayUniqueIdMap.forEach((value, key) => {
        state[key] = value
    })
    return state
}
